import type { User } from '@/types/auth';
import { ADMIN_MODULES } from '@/constants/adminModules';
import { ROUTES } from '@/constants/routes';

export function hasModuleAccess(
  user: Pick<User, 'role' | 'effectivePermissions'> | null | undefined,
  moduleKey: string,
): boolean {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  return user.effectivePermissions?.includes(moduleKey) ?? false;
}

export function hasPathAccess(
  user: Pick<User, 'role' | 'effectivePermissions'> | null | undefined,
  pathname: string,
  resolveModuleKey: (pathname: string) => string | null,
): boolean {
  const moduleKey = resolveModuleKey(pathname);
  if (!moduleKey) return true;
  return hasModuleAccess(user, moduleKey);
}

export function getAccessibleFallbackRoute(
  user: Pick<User, 'role' | 'effectivePermissions'> | null | undefined,
): string {
  if (!user) return ROUTES.LOGIN;
  if (hasModuleAccess(user, 'dashboard')) return ROUTES.DASHBOARD;

  const firstModule = ADMIN_MODULES.find((module) => hasModuleAccess(user, module.key));
  if (firstModule) return firstModule.route;

  return ROUTES.PROFILE;
}

export function hasAnyModuleAccess(
  user: Pick<User, 'role' | 'effectivePermissions'> | null | undefined,
  moduleKeys: string[],
): boolean {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  return moduleKeys.some((key) => user.effectivePermissions?.includes(key));
}
